const PENDING_SIGNUP_INTENT_KEY = "bb_pending_signup_intent";
const NONCE_PATTERN = /^[A-Za-z0-9_-]{16,64}$/;

function randomNonce(): string | null {
  try {
    const bytes = new Uint8Array(24);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(36).padStart(2, "0"))
      .join("")
      .slice(0, 32);
  } catch {
    return null;
  }
}

export function markPendingSignupIntent(): string | null {
  const nonce = randomNonce();
  if (!nonce) return null;
  try {
    window.sessionStorage.setItem(PENDING_SIGNUP_INTENT_KEY, nonce);
  } catch {
    // Without persistence there can be no safe callback attribution.
    return null;
  }
  return nonce;
}

export function consumePendingSignupIntent(nonce: string): boolean {
  if (!NONCE_PATTERN.test(nonce)) return false;
  try {
    if (window.sessionStorage.getItem(PENDING_SIGNUP_INTENT_KEY) !== nonce)
      return false;
    window.sessionStorage.removeItem(PENDING_SIGNUP_INTENT_KEY);
    return true;
  } catch {
    return false;
  }
}

export function matchesPendingSignupIntent(nonce: string): boolean {
  if (!NONCE_PATTERN.test(nonce)) return false;
  try {
    return window.sessionStorage.getItem(PENDING_SIGNUP_INTENT_KEY) === nonce;
  } catch {
    return false;
  }
}

export function clearPendingSignupIntent(): void {
  try {
    window.sessionStorage.removeItem(PENDING_SIGNUP_INTENT_KEY);
  } catch {
    // Best effort only.
  }
}

export function isValidSignupIntent(nonce: string | null): nonce is string {
  return nonce !== null && NONCE_PATTERN.test(nonce);
}

export const SIGNUP_CALLBACK_PATH = "/sign-up";

export function clearSignupCallbackParams(): void {
  try {
    const url = new URL(window.location.href);
    // Next integrates history writes with its router. A same-URL replacement
    // during an ordinary session change can cancel an in-flight sign-in push.
    if (!url.searchParams.has("bb_signup") && !url.searchParams.has("intent")) {
      return;
    }
    url.searchParams.delete("bb_signup");
    url.searchParams.delete("intent");
    window.history.replaceState(
      null,
      "",
      `${url.pathname}${url.search}${url.hash}`,
    );
  } catch {
    /* browser history is best effort */
  }
}
